import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponCreateTemplate } from 'components/Templates'

const CouponCreate: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'新規クーポン作成'}>
      <CouponCreateTemplate />
    </Layout>
  )
}

export default CouponCreate
